import { Component, EventEmitter, HostBinding, Input, Output } from '@angular/core';
import * as _ from 'lodash';

import { StatusModel } from '../status.model';

@Component({
  moduleId: module.id,
  selector: 'statuses-panel',
  templateUrl: 'statuses-panel.component.html',
  styleUrls: ['statuses-panel.component.scss']
})
export class StatusesPanelComponent {
  @Input() statuses: Array<{}> = [];

  @Input() statusModel: StatusModel;

  @Input() allStatusesTitle: string = 'All statuses';
  @Input() allStatusesCount: number;

  @Input() showOnlyAllStatusesTitle: boolean = false; // to show only what was passed in allStatusesTitle

  @Input() selectedName: string;

  @Input() showDropdown: boolean = true; // allows to show/hide dropdown menu

  @HostBinding('class.small-panel')
  @Input() isSmall: boolean = false;

  @HostBinding('class.version-2')
  @Input() isVersion2: boolean = false;

  @Output() statusSelected  = new EventEmitter();

  // getters
  get totalCount(): number {
    if (!_.size(this.statuses)) { return this.allStatusesCount; }
    return _.reduce(this.statuses, (sum, status: any) => {
      return sum + status.searchAmount;
    }, 0);
  }

  get title(): string {
    if (this.showOnlyAllStatusesTitle) { return this.allStatusesTitle; }
    return this.selectedName ? this.selectedName :
      (this.statusModel ? this.statusModel.name : this.allStatusesTitle);
  }

  // public
  getStatusTitle(status: any): string {
    if (!status) { return ''; }

    const title = status.replace(/-|_/g, ' ').trim();
    return title.charAt(0).toUpperCase() + title.slice(1);
  }

  mapStatusToBadgeBgColor(status: string): string {
    if (!status) { return ''; }
    if (this.showOnlyAllStatusesTitle) { return 'badge-info'; }
    switch (status.toLowerCase()) {
      case 'draft':
      case 'changed':
      case 'invalid':
      case 'not uploaded':
      case 'rejected': // receivers
        return 'badge-danger';
      case 'in review':
      case 'unassigned':
      case 'duplicate':
      case 'requested': // receivers
        return 'badge-warning';
      case 'approved': // products, receivers
      case 'new':
      case 'assigned':
      case 'valid':
        return 'badge-success';
      case 'no status': // receivers
        return 'badge-no-data';
      case 'unchanged':
      case 'published':
        return 'badge-primary';
      case 'all':
        return 'badge-info';
      case 'uploaded':
        return 'badge-uploaded';
      case 'imported':
        return 'badge-imported';
      default:
        return 'approved';
    }
  }

  mapStatusToBadgeTextColor(status: string): string {
    if (!status) { return ''; }
    switch (status.toLowerCase()) {
      case 'draft':
      case 'changed':
      case 'invalid':
      case 'in review':
      case 'unassigned':
      case 'duplicate':
      case 'approved':
      case 'new':
      case 'assigned':
      case 'valid':
      case 'unchanged':
      case 'published':
      case 'all':
      case 'uploaded':
      case 'imported':
      case 'not uploaded':
        return 'color-white';
      default:
        return 'color-white';
    }
  }

  onStatusSelect(event: any) {
    this.statusSelected.emit(event.name);
  }

  onDropdownStatusClick(name: string) {
    this.statusSelected.emit(name);
  }
}
